module.exports = __webpack_public_path__ + "static/media/team-elizabeth.35b16fb6.jpg";